import { Component } from "react"
import PropTypes from "prop-types"
import { map, size } from "lodash"
import pluralize from "pluralize"
import { DialogContent, DialogActions, Button } from "@mui/material"
import "./styles.scss"

export default class ModelChange extends Component {
  static propTypes = {
    modifiedScreens: PropTypes.array.isRequired,
    close: PropTypes.func,
    changeModel: PropTypes.func.isRequired,
  }

  save = () => {
    const { changeModel, close } = this.props
    changeModel()
    close()
  }

  render() {
    const { close, modifiedScreens } = this.props

    return <>
      <DialogContent className="modules_portfolio-root_components_model-change">
        <div className="upper-part">Changing the model will reset your changes in the following {pluralize("screen", size(modifiedScreens))} :</div>
        <div className="screens-list">
          {map(modifiedScreens, elem => <div>{elem}</div>)}
        </div>
        <div className="bottom-part">Would you still like to proceed with the model change?</div>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" onClick={this.save}>
          Change Model
        </Button>
      </DialogActions>
    </>
  }
}
